import { useEffect } from "react";

const GHL_FORM_ID = "6bmvjXP6XWQ9TjT80ny0";

export const RsvpModal = ({ open, onClose }) => {
  useEffect(() => {
    if (!open) return;
    const onKey = (e) => e.key === "Escape" && onClose();
    document.addEventListener("keydown", onKey);
    document.body.style.overflow = "hidden";
    return () => {
      document.removeEventListener("keydown", onKey);
      document.body.style.overflow = "";
    };
  }, [open, onClose]);

  if (!open) return null;

  return (
    <div className="sm-modal" onClick={onClose} data-testid="rsvp-modal">
      <div
        className="sm-modal-panel"
        onClick={(e) => e.stopPropagation()}
        role="dialog"
        aria-modal="true"
        aria-label="In Person Healing Social - Registration"
      >
        <div className="sm-modal-head">
          <p className="sm-label">Reserve · Healing Social</p>
          <button
            type="button"
            className="sm-modal-close sm-label"
            onClick={onClose}
            data-testid="rsvp-modal-close"
          >
            Close ✕
          </button>
        </div>
        <iframe
          src={`https://api.leadconnectorhq.com/widget/form/${GHL_FORM_ID}`}
          className="sm-modal-iframe"
          id={`popup-${GHL_FORM_ID}`}
          data-form-name="In Person Healing Social - Registration"
          data-form-id={GHL_FORM_ID}
          title="In Person Healing Social - Registration"
          data-testid="rsvp-iframe"
        />
      </div>
    </div>
  );
};
